<script lang="ts">
    import ChevronDownIcon from "../../Icons/meta/ChevronDownIcon.svelte";
    import HeaderMenuItem from "./HeaderMenuItem.svelte";

    export let label: string;
    export let displayItems: boolean = false;
    export let classes: string = "";
</script>

<div class="pt-2 first:pt-0 {classes}">
    <button
        class="hover:bg-mdark/10 flex flex-row justify-between cursor-pointer mb-1 w-full text-sm py-px px-1.5"
        on:click={() => (displayItems = !displayItems)}
        aria-label="Показать/скрыть элементов меню"
        data-testid="profilemenuaccordeon"
    >
        <HeaderMenuItem {label} />
        <div
            class="transition-all group-hover:bg-mdark/10 p-0 m-0 outline-none rounded-lg aspect-square flex items-center justify-center"
        >
            <ChevronDownIcon
                classes={`transform transition ${!displayItems ? "" : "rotate-180"}`}
                height="h-4"
                width="w-4"
            />
        </div>
    </button>
    {#if displayItems}
        <slot />
    {/if}
</div>
